function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  r: "49.79%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0,
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.059841,
  offset: 0.49506
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.80207,
  offset: 1
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 13,
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 7,
  fill: "#F66363",
  stroke: "#fff",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 11)",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("line", {
  x2: 4,
  y1: 4,
  y2: 1.4078e-13
}), /*#__PURE__*/React.createElement("line", {
  transform: "translate(2 2) scale(-1 1) translate(-2 -2)",
  x2: 4,
  y1: 4,
  y2: 1.168e-13
})));
function SvgWorkplaceUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceUnavailable);
export default __webpack_public_path__ + "static/media/workplace_unavailable.7713a3f72fb6de2e590015354b58ba67.svg";
export { ForwardRef as ReactComponent };